export const footerContent = [
  {
    heading: 'Ford Press',
    links: [{
      heading: 'Media',
      href: 'https://media.ford.com/'
    },{
      heading: 'Sustainability Report',
      href: 'https://corporate.ford.com/microsites/sustainability-report-2017-18/index.html?intcmp=BFA-Microsite-FMC-CTA-20200515'
    },{
      heading: 'Annual Report',
      href: 'https://annualreport.ford.com/Y2019/default.aspx'
    },{
      heading: 'Ford Fund Annual Report',
      href: 'https://www.fordfund.org/current-events/326-2019-annual-report'
    }]
  },
  {
    heading: 'Contact Us',
    links: [{
      heading: 'Your Vehicles',
      href: 'https://corporate.ford.com/contact-us.html'
    },{
      heading: 'Ford Motor Company',
      href: 'https://corporate.ford.com/contact-us.html#tab2'
    },{
      heading: 'Shareholder Services',
      href: 'https://corporate.ford.com/contact-us.html#tab3'
    },{
      heading: 'Investor Relations',
      href: 'https://corporate.ford.com/contact-us.html#tab4'
    }]
  },
  {
    heading: 'Around The Oval',
    links: [{
      heading: 'Ford Merchandise',
      href: 'https://merchandise.ford.com/'
    },{
      heading: 'Ford Performance',
      href: 'https://performance.ford.com/'
    },{
      heading: 'Ford Driving Skills for Life',
      href: 'https://www.drivingskillsforlife.com/'
    },{
      heading: 'Warriors In Pink',
      href: 'https://www.warriorsinpink.ford.com/'
    }]
  },
  {
    heading: 'Customer Support',
    links: [{
      heading: 'Ford Support U.S.',
      href: 'https://owner.ford.com/'
    },{
      heading: 'Lincoln Support U.S.',
      href: 'https://owner.lincoln.com/'
    },{
      heading: 'Recalls',
      href: 'https://owner.ford.com/tools/account/maintenance/recalls.html'
    },{
      heading: 'FordPass',
      href: 'https://owner.ford.com/fordpass.html'
    }]
  },
  {
    heading: 'Shop',
    links: [{
      heading: 'Ford U.S.',
      href: 'https://www.ford.com'
    },{
      heading: 'Lincoln U.S.',
      href: 'https://www.lincoln.com'
    },{
      heading: 'Global',
      href: 'https://corporate.ford.com/global-links.html?intcmp=BFA-Microsite-FMC-CTA-20200515'
    }]
  },
];

export const footerLinks = [{
    heading: '© 2020 Ford Motor Company',
    href: 'https://corporate.ford.com/legal/copyright.html?intcmp=BFA-Microsite-FMC-CTA-20200515'
  }, {
    heading: 'Site Feedback',
    href: 'https://secure.opinionlab.com/ccc01/comment_card.asp?time1=1588290086683&time2=1588357654299&prev=&referer=https%3A%2F%2Fcorporate%2Eford%2Ecom%2Fundefined%2Ehtml&height=1080&width=1920&custom_var=https://corporate.ford.com/homepage.html'
  },{
    heading: 'Privacy Policy',
    href: 'https://www.ford.com/help/privacy/'
  },{
    heading: 'SSN Privacy',
    href: 'https://corporate.ford.com/content/dam/corporate/en/shared-content/navigation/footer/Social-Security-Number-Privacy-Statement-081109.pdf?intcmp=BFA-Microsite-FMC-CTA-20200515'
  },{
    heading: 'Cookie Settings',
    href: '#cookie-settings'
  },{
    heading: 'Your California Privacy Rights',
    href: 'https://www.ford.com/help/privacy/#caPrivacy'
  },{
    heading: 'Human Trafficking: CA Disclosure',
    href: 'https://corporate.ford.com/content/dam/corporate/en/company/corporate-governance/sr17-human-trafficking-disclosure-statment.pdf?intcmp=BFA-Microsite-FMC-CTA-20200515'
  },{
    heading: 'Conflict Minerals',
    href: 'https://corporate.ford.com/conflict-minerals-report?intcmp=BFA-Microsite-FMC-CTA-20200515'
  },{
    heading: 'Pay Transparency',
    href: 'https://corporate.ford.com/content/dam/corporate/en/careers/Pay%20Transparency/Pay-Transparency-Policy-Statement-2017.pdf?intcmp=BFA-Microsite-FMC-CTA-20200515'
  },{
    heading: 'Open Source Notes',
    href: 'https://corporate.ford.com/ford-open-source.html?intcmp=BFA-Microsite-FMC-CTA-20200515'
  },{
    heading: 'Terms and Conditions',
    href: 'https://www.ford.com/help/terms/'
  },
]
